import { ReactChild } from 'react'

import { CustomForm, FormStyles } from './form.styles'

interface FormProps extends FormStyles {
  children?: ReactChild | ReactChild[] | Element
  onSubmit: React.FormEventHandler<HTMLFormElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLFormElement>
}

export const Form = ({
  children,
  onSubmit,
  marginLeft,
  marginRight,
  marginBottom,
  padding,
  boxShadow,
  onKeyDown,
  marginTop
}: FormProps) => (
  <CustomForm
    onSubmit={onSubmit}
    marginLeft={marginLeft}
    marginRight={marginRight}
    marginBottom={marginBottom}
    padding={padding}
    onKeyDown={onKeyDown}
    boxShadow={boxShadow}
    marginTop={marginTop}
    autoComplete="new-password"
  >
    {children}
  </CustomForm>
)
